export const MODULE_NAME = 'views/cottage-bookmarks'

export const PRESELECTED_IDS = [1]
